import {Component, EventEmitter, Input, Output} from '@angular/core';
import {WizardState} from '../../wizard-state.model';

interface ChecklistItem {
  label: string;
  feito: boolean;
}

@Component({
  selector: 'app-step-conclusao',
  templateUrl: './step-conclusao.component.html',
  styleUrls: ['./step-conclusao.component.scss']
})
export class StepConclusaoComponent {
  @Input() state: WizardState;
  @Input() empresa: any = {};
  @Output() onConcluir = new EventEmitter<void>();

  get checklist(): ChecklistItem[] {
    const items: ChecklistItem[] = [
      {label: 'Nome da loja configurado', feito: !!this.state.nomeEmpresa},
      {label: 'Logo definido', feito: !!this.state.logoUrl || !!this.empresa.logo},
      {label: 'Endereço online definido', feito: !!this.state.subdominio},
      {label: 'Modo de venda configurado', feito: this.state.modosDeVenda.length > 0}
    ];

    if (this.state.modosDeVenda.includes('delivery')) {
      items.push({label: 'Entrega configurada', feito: true});
    }

    const totalProdutos = this.totalProdutos;
    items.push({label: `${totalProdutos} produto${totalProdutos !== 1 ? 's' : ''} cadastrado${totalProdutos !== 1 ? 's' : ''}`, feito: totalProdutos > 0});

    items.push({label: 'Tema do cardapio selecionado', feito: !!this.state.temaSelecionado});

    return items;
  }

  get totalProdutos(): number {
    if (this.state.caminhoEscolhido === 'importar') {
      return this.state.produtosImportados.filter(p => p.selecionado).length;
    }
    if (this.state.caminhoEscolhido === 'template') {
      return this.state.produtosTemplate.filter(p => p.selecionado).length;
    }
    return this.state.produtosManuais.length;
  }

  get proximosPassos(): string[] {
    const passos = [];
    if (!this.state.logoUrl && !this.empresa.logo) passos.push('Adicionar logo');
    passos.push('Configurar horarios de funcionamento');
    if (!this.state.temaSelecionado) passos.push('Personalizar cores e tema');
    passos.push('Adicionar mais produtos');
    passos.push('Configurar formas de pagamento');
    return passos;
  }

  concluir() {
    this.onConcluir.emit();
  }
}
